import React, { Suspense } from "react";

class ChunkBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed) {
      return (
        <div role="alert" className="p-4">
          <p>This part of the page couldn’t load. Please reload to try again.</p>
          <button className="ad-view-mode-button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function lazyComponent(loader) {
  const Component = React.lazy(loader);
  return function LazyComponent(props) {
    return (
      <ChunkBoundary>
        <Suspense fallback={<div role="status" className="p-4">Loading…</div>}>
          <Component {...props} />
        </Suspense>
      </ChunkBoundary>
    );
  };
}
